import React, { useEffect, useRef } from 'react';
import '../styles/snowfall.css';

const SnowfallEffect = () => {
  const snowRef = useRef(null);

  useEffect(() => {
    const snowContainer = snowRef.current;

    if (snowContainer) {
      for (let i = 0; i < 20; i++) {
        const flake = document.createElement('img');
        flake.src = '/images/silverFlake.png'; // ✅ since it's in public
        flake.alt = 'snowflake';
        flake.className = 'silver-snowflake';
        flake.style.left = `${Math.random() * 100}%`;
        flake.style.top = `${-50 + Math.random() * 100}px`;
        flake.style.animationDuration = `${5 + Math.random() * 4}s`;
        flake.style.opacity = (0.4 + Math.random() * 0.4).toFixed(2);
        flake.style.transform = `scale(${0.6 + Math.random() * 0.6})`;
        snowContainer.appendChild(flake);
      }
    }
  }, []);

  return <div className="silver-snow-overlay" ref={snowRef}></div>;
};

export default SnowfallEffect;
